// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__OETC9","header":"ReportDetails_header__dWeZx","title":"ReportDetails_title__2S1lt","left":"ReportDetails_left__2IVm-"};